export const PenMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <path
      d="M31 5 L43 17 L20 40 L7 42 L9 29 Z"
      fill="#FFD23F"
      stroke="#1A1B23"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path d="M28 12 L37 21" stroke="#1A1B23" strokeWidth="3" strokeLinecap="round" />
    <circle cx="38" cy="10" r="3" fill="#D92B38" stroke="#1A1B23" strokeWidth="2" />
  </svg>
);

export const BrandLogo = ({ dark = false }) => (
  <div className="flex items-center gap-2.5" data-testid="navbar-logo">
    <PenMark />
    <div className="leading-none">
      <span className={`block font-head text-base font-black tracking-tight ${dark ? "text-cream" : "text-ink"}`}>
        BELIEVE
      </span>
      <span className="block font-display text-sm font-semibold text-gold -mt-0.5">in yourself</span>
    </div>
  </div>
);
